import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Mail, CheckCircle2, AlertCircle } from "lucide-react";

export default function Unsubscribe() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const [state, setState] = useState({ loading: true, ok: false, message: "" });

    useEffect(() => {
        if (!token) {
            setState({ loading: false, ok: false, message: "No unsubscribe token in URL." });
            return;
        }
        api.get(`/unsubscribe/${token}`)
            .then((r) => setState({ loading: false, ok: !!r.data?.ok, message: r.data?.message || "" }))
            .catch((e) => setState({
                loading: false,
                ok: false,
                message: e?.response?.data?.detail || "Something went wrong. Please try again.",
            }));
    }, [token]);

    return (
        <div className="max-w-xl mx-auto px-5 py-20" data-testid="unsubscribe-page">
            <div className="card-sticker bg-white p-10 text-center">
                {state.loading ? (
                    <>
                        <Mail className="w-12 h-12 mx-auto text-coral" strokeWidth={2.5} />
                        <h1 className="font-heading text-3xl font-bold mt-4">Unsubscribing you...</h1>
                    </>
                ) : state.ok ? (
                    <>
                        <CheckCircle2 className="w-14 h-14 mx-auto text-mint" strokeWidth={2.5} />
                        <h1 className="font-heading text-3xl font-bold mt-4">You're unsubscribed</h1>
                        <p className="text-ink/70 mt-3">{state.message}</p>
                        <p className="mt-6 text-sm italic text-ink/80">
                            "The Lord bless you and keep you." — Numbers 6:24 (ESV)
                        </p>
                        <Link to="/" className="btn-sticker bg-sun text-ink mt-8 inline-flex" data-testid="unsub-home-btn">
                            Back to homepage
                        </Link>
                    </>
                ) : (
                    <>
                        <AlertCircle className="w-14 h-14 mx-auto text-coral" strokeWidth={2.5} />
                        <h1 className="font-heading text-3xl font-bold mt-4">Hmm, we hit a snag</h1>
                        <p className="text-ink/70 mt-3">{state.message}</p>
                        <Link to="/" className="btn-sticker bg-sun text-ink mt-8 inline-flex">
                            Back to homepage
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
}
